import { ADD_IN_POPUP_LIST, REMOVE_POPUP_FROM_LIST } from '../actionTypes/popupActionTypes';
import getDeviceType from '../utils/getDeviceType';
const { isPhone } = getDeviceType();

export const addPopup = payload => dispatch => {
  if (isPhone) {
    // this is done to prevent toast to open on previous modal if we are switching modal
    const addPopupTime = setTimeout(() => {
      dispatch({
        type: ADD_IN_POPUP_LIST,
        payload
      });
      clearTimeout(addPopupTime);
    });
  } else {
    dispatch({
      type: ADD_IN_POPUP_LIST,
      payload
    });
  }
};

export function removePopup(payload) {
  return {
    type: REMOVE_POPUP_FROM_LIST,
    payload
  };
}
